export const constant = {
    routerLinkMap: {
        'article' : '/detail/default/',
        'medicine' : '/detail/medicine/',
        'consilia' : '/detail/consilia/'},
}